import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SearchInput from 'components/search/Input';
import TypeaheadResults from 'components/search/TypeaheadResults';
import Nav from './Nav';
import Tags from './Tags';
import styles from './header.module.scss';

const Header = ({tags, isThin, articleNavigation}) => (
  <section
    className={classNames(
      'section',
      'header',
      'has-background-primary',
      styles.Header,
      {
        [styles['Header--thin']]: isThin,
      }
    )}
  >
    <div className={styles.JaggedHeroContent}>
      <Nav articleTree={articleNavigation} centerRight={isThin} />
      {isThin === false && (
        <div
          className={classNames(
            'container',
            'is-small',
            'has-text-centered',
            'container-960'
          )}
        >
          <h2 className={classNames('has-text-white', styles.Header__text)}>
            How can we help?
          </h2>
          <SearchInput>
            {({query, typeaheadResults}) => (
              <TypeaheadResults query={query} results={typeaheadResults} />
            )}
          </SearchInput>
          <Tags tags={tags} />
        </div>
      )}
    </div>
    <div className={styles.JaggedHeroBackground}>
      <div className={classNames(styles.Jag, styles.Jag1)} />
      <div className={classNames(styles.Jag, styles.Jag2)} />
      <div className={styles.WithAngle} />
    </div>
  </section>
);

Header.propTypes = {
  articleNavigation: PropTypes.objectOf(PropTypes.object).isRequired,
  isThin: PropTypes.bool,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ),
};

Header.defaultProps = {
  tags: [],
  isThin: false,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js